export default __webpack_public_path__ + "static/media/img-16-coven.5a05fd35.jpg";